import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
const useEnsureData = (selectHasData, createFetchAction) => {
    const dispatch = useAppDispatch();
    const hasData = useAppSelector(selectHasData);
    useEffect(() => {
        if (!hasData) {
            dispatch(createFetchAction());
        }
    }, [hasData, dispatch, createFetchAction]);
    return !!hasData;
};
export default useEnsureData;
